import { isDevelopment } from './is-development';
var messageCache = {};
export function warnOnce(component, message) {
    if (isDevelopment) {
        var warning = "[AwsUi] [" + component + "] " + message;
        if (!messageCache[warning]) {
            messageCache[warning] = true;
            console.warn(warning);
        }
    }
}
//# sourceMappingURL=logging.js.map